export const formatCheckBoxValue = (value?: string, isFalse?: boolean) => {
  value = value?.trim().toLocaleUpperCase();

  if (isFalse) {
    return value === 'NO' || value === '否' || value === 'FALSE' || value === '错';
  }

  return value === 'YES' || value === '是' || value === 'TRUE' || value === '对';
};
